/**
 * unload.js [AA 1/24]
 * --------------------
 * Pairs with 'preload.js'
 * Inserts deferred scripts, videos, and iframes into the document after content has loaded
 * Use the data attribute [data-load-priority] to skip deferring
 * @example
 * <script src="example.js" data-load-priority></script>
 * */

; (function unloadJS() {

  function loadScript(e) {
    const hasPriority = e.hasAttribute('data-load-priority')
    if (hasPriority) return

    var t = document.createElement('script')

    for (a = 0; a < e.attributes.length; a++) {
      var r = e.attributes[a]
      t.setAttribute(r.name, r.value)
    }

    t.innerHTML = e.innerHTML

    if (e.dataset.src) {
      t.src = e.dataset.src
    }

    if (e.dataset.type) {
      t.type = e.dataset.type
    } else {
      t.type = 'text/javascript'
    }

    e.parentNode.insertBefore(t, e)
    e.parentNode.removeChild(e)
  }

  document.querySelectorAll("script[data-src]").forEach(loadScript)
})()
